import React from "react";
import { TransferContainer } from "../../../containers";

const Transfer = (props) => {
  return <TransferContainer {...props} />;
};

export default Transfer;
